import React from 'react'
import styles from '../PlanManagementV3.module.scss'

export default function SummaryCard({
  label,
  value,
  accentColor,
  active = false,
  onClick,
}: {
  label: string
  value: number
  /** Small colored dot before the label, matching the row status badge. */
  accentColor?: string
  /** Highlights the card as the currently applied filter. */
  active?: boolean
  /** Makes the card a toggle button (e.g. to filter the grid by status). */
  onClick?: () => void
}) {
  const content = (
    <>
      <div className={styles.summaryCardLabel}>
        {accentColor && (
          <span
            className={styles.summaryCardDot}
            style={{ background: accentColor }}
          />
        )}
        {label}
      </div>
      <div className={styles.summaryCardValue}>{value.toLocaleString()}</div>
    </>
  )

  if (!onClick) {
    return <div className={styles.summaryCard}>{content}</div>
  }

  return (
    <button
      type="button"
      aria-pressed={active}
      className={[
        styles.summaryCard,
        styles.summaryCardClickable,
        active ? styles.summaryCardActive : null,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={onClick}
    >
      {content}
    </button>
  )
}
